import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder/ngx';
import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
//import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { OAuthModule } from 'angular-oauth2-oidc';
import {
  IonicSelectableCloseButtonTemplateDirective, IonicSelectableComponent, IonicSelectableItemTemplateDirective,
  IonicSelectableSearchFailTemplateDirective
} from 'ionic-selectable';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AvvioRilevazionePage } from './avvio-rilevazione/avvio-rilevazione.page';
import { CaricaPresenzePage } from './carica-presenze/carica-presenze.page';
import { CopiaPresenzePage } from './copia-presenze/copia-presenze.page';
import { InserisciConfermaComponent } from './elenco-presenti/inserisci-conferma/inserisci-conferma.component';
import { ModificaPresenzaComponent } from './elenco-presenti/modifica-presenza/modifica-presenza.component';
import { HttpInterceptor2 } from './http.interceptor';
import { InvioNotificaPage } from './invio-notifica/invio-notifica.page';
import { ManagePresenzaPage } from './manage-presenza/manage-presenza.page';
import { NotifyingPage } from './notifying/notifying.page';
import { ConsensoService } from './services/consenso-service/consenso.service';
import { DataService } from './services/data-service';
import { InfoPopoverComponent } from './shared/info-popover/info-popover.component';
import { InfoScartiPresenzeComponent } from './shared/info-scarti-presenze/info-scarti-presenze.component';
import { ModFreqViewerComponent } from './shared/mod-freq-viewer/mod-freq-viewer.component';
import { OrderpopoverComponent } from './shared/orderpopover/orderpopover.component';
import { ModificaRilevazioneComponent } from './shared/ril-viewer/modifica-rilevazione/modifica-rilevazione.component';
import { RilNotesComponent } from './shared/ril-viewer/ril-notes/ril-notes.component';
import { SharedModule } from './shared/shared.module';
import { ReportComponent } from './storico-rilevazioni/report/report.component';
import { VerificaPresenzaPage } from './verifica-presenza/verifica-presenza.page';
import { InfoSuddivisionePage } from './info-suddivisione/info-suddivisione.page';

// import { registerLocaleData } from '@angular/common';
// import localeIt from '@angular/common/locales/it';
// import { DateFnsModule, DateFnsConfigurationService } from 'ngx-date-fns';
// import { it } from 'date-fns/locale';
// const itConfig = new DateFnsConfigurationService();
// itConfig.setLocale(it);

/**
 * Il componente che carica le traduzioni
 * TODO: caricare da remoto in base al tenant con config server?
 */
// required for AOT compilation
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent, InvioNotificaPage, InfoPopoverComponent, InfoScartiPresenzeComponent,
    AvvioRilevazionePage, NotifyingPage, VerificaPresenzaPage,
    OrderpopoverComponent, RilNotesComponent, ModificaRilevazioneComponent,
    CopiaPresenzePage, CaricaPresenzePage, ModFreqViewerComponent, ManagePresenzaPage,
    InserisciConfermaComponent, ReportComponent, ModificaPresenzaComponent, InfoSuddivisionePage
  ],
  bootstrap: [AppComponent],
  imports: [
    OAuthModule.forRoot(),
    BrowserModule,
    IonicModule.forRoot({backButtonText: '', backButtonIcon: 'arrow-back-outline'}),
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    IonicSelectableComponent,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    IonicSelectableCloseButtonTemplateDirective,
    IonicSelectableSearchFailTemplateDirective,
    IonicSelectableItemTemplateDirective
  ],
    providers: [
      DataService,
      StatusBar,
      SplashScreen,
      HttpClient,
      Geolocation,
      AppVersion,
      ConsensoService,
      SocialSharing,
      File,
      FileOpener,
      NativeGeocoder,
      Diagnostic,
      LocationAccuracy,
      InAppBrowser,
      OneSignal,
      {
        provide: RouteReuseStrategy,
        useClass: IonicRouteStrategy
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpInterceptor2,
        multi: true
      },
      provideHttpClient(withInterceptorsFromDi()),
    ]
  })
  export class AppModule {}
